import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthAPI } from '../api';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    if (!sessionId) { navigate('/login', { replace: true }); return; }
    AuthAPI.exchange(sessionId)
      .then((user) => {
        setUser(user);
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/workspace', { replace: true, state: { user } });
      })
      .catch(() => setError('Sign-in failed. Please try again.'));
  }, [navigate, setUser]);

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-[#F5F6FB]" data-testid="auth-callback">
      {error ? (
        <div className="text-center">
          <p className="text-[15px] text-[#E5387B] font-medium">{error}</p>
          <button onClick={() => navigate('/login', { replace: true })} className="mt-3 text-[14px] text-[#0A1551] underline">Back to login</button>
        </div>
      ) : (
        <div className="w-8 h-8 border-2 border-[#0F766E] border-t-transparent rounded-full animate-spin" />
      )}
    </div>
  );
};

export default AuthCallback;
